// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StickyElement_wrapper__c7K2I","stickyContainerActive":"StickyElement_stickyContainerActive__n0jjT"};